
import { HiddenCapabilitiesSection as GenericHiddenCapabilitiesSection } from "@/components/services/specializations/HiddenCapabilitiesSection";

export const HiddenCapabilitiesSection = () => {
  // Define capabilities with both before and after percentages
  const capabilities = [
    {
      title: "Advanced Threat Protection",
      description: "Automated threat detection and remediation capabilities to protect against sophisticated threats including zero-day exploits and phishing attacks.",
      percentage: 30, // Before edgefi
      afterPercentage: 95 // After edgefi
    },
    {
      title: "Data Loss Prevention",
      description: "Content inspection tools that detect, monitor, and protect sensitive information across emails, documents, and cloud storage.",
      percentage: 25,
      afterPercentage: 90
    },
    {
      title: "Identity & Access Controls",
      description: "Conditional access policies, multi-factor authentication, and just-in-time access management to control resource access.",
      percentage: 35,
      afterPercentage: 98
    },
    {
      title: "Security Monitoring & Analytics",
      description: "Advanced security dashboards, incident correlation, and automated security assessments to identify risks.",
      percentage: 20,
      afterPercentage: 85
    }
  ];

  return (
    <GenericHiddenCapabilitiesSection
      platform="Microsoft 365"
      capabilities={capabilities}
    />
  );
};
